/**
 * @generated SignedSource<<096a62b5066089bd0dd49ceba4f998ef>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DisplaySettingsCta_viewer$data = {
  readonly currencies: ReadonlyArray<string | null> | null;
  readonly geography: {
    readonly countries: ReadonlyArray<{
      readonly abbreviation: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "DisplaySettingsCta_viewer";
};
export type DisplaySettingsCta_viewer$key = {
  readonly " $data"?: DisplaySettingsCta_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplaySettingsCta_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplaySettingsCta_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Geography",
      "kind": "LinkedField",
      "name": "geography",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GeographyObject",
          "kind": "LinkedField",
          "name": "countries",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "abbreviation",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2989583ca9a5c927b8daf0d15268e101";

export default node;
